// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.switch {
    position: relative;
    display: inline-block;
    width: 53px !important;
    height: 28px !important;
  }
  
  .switch input { 
    opacity: 0;
    width: 0;
    height: 0;
  }
  
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: .4s;
  }
  
  .slider:before {
    position: absolute;
    content: "";
    height: 22px !important;
    width: 22px !important;
    left: 3px !important;
    bottom: 3px;
    background-color: white;
    transition: .4s;
  }
  
  input:checked + .slider {
    background-color: #105293;
  }
  
  input:focus + .slider {
    box-shadow: 0 0 1px #2196F3;
  }
  
  input:checked + .slider:before {
    transform: translateX(26px);
  }
  
  .slider.round {
    border-radius: 34px;
  }
  
  .slider.round:before {
    border-radius: 50%;
  }

  .prod_desc{
    font-size: 12px;
    width: 51%;
    font-weight: 500;
    margin-left: 3px;
    display: flex;
    align-self: flex-start;
    flex-direction: column;
  }


  .searchDiv{
    border: 1px solid #105293;
  }

  .searchDiv select {
    font-size: 13px;
    font-weight: 600;
    background: #105293;
    color: white;
  }

  .searchDiv input{
    border: none;
    outline: none;
    font-size: 12px;
    
  }

  .btnvar{
    height: 31px !important;
  }

  .filterselection{
    transition: opacity 1s ease, transform 1s ease;
    border-radius: 10px;
    width: 100%;
    background-color: white;
    min-height: 250px;
    position: absolute;
    z-index: 10;
  }

  /* React Tabs  */

.catelog .custom-tab-list {
  list-style: none;
  display: flex;
  background-color: transparent;
}

.catelog .custom-tab-list .custom-tab {
  cursor: pointer;
  height: 0;
  width: 33.33%;
  border-bottom: 35px solid #CCCCCC;
  box-sizing: border-box;
  background: white;
  outline: none;
  line-height: 2;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  color: #000;

  &:hover {
    background-color: #d0d0d0;
  }

  &.react-tabs__tab--selected {
    color: #105293;
    transition: 300ms;
    border-radius: 20px;
    border-bottom: 3px solid
  }
}

.inputWidth{
  width: 75%;
}

.modalTrigerButton {
  background: #d3d3d3;
  border-radius: 14px;
  color: #000;
  cursor: pointer;
  font-size: 11px;
  font-weight: 600;
  padding: 6px;
}
.functionalButtons {
  background: #d3d3d3;
  border-radius: 12px;
  color: #000;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  height: 25px;
  padding-top: 3px;
  text-align: center;
  width: 70px;
}

.syncContainers{
  display: flex;
  align-items: center;
  gap: 20px;
}
.syncContainers input{
  width: 20px;
  height: 20px;
}
.syncContainers label{
  font-size: 17px;
  color: black;
}

@media screen and (max-width: 450px) {
  .inputWidth{
    width: 100%;
  }

  .inputWidth::placeholder{
    font-size: 12px;
  }
  

  .catelog .custom-tab-list .custom-tab{
    font-size: 10px;
  }

  .filterWidth{
    width: 55% !important;
  }
  .sortWidth{
    width: 40% !important;
  }

  .prod_desc .genericlabel{
    font-size: 10px;
  }

  .badge{
    font-size: 55% !important;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 42px !important;
    height: 21px !important;
  }

  input:checked + .slider:before {
    transform: translateX(17px) !important;
  }

  .slider:before{
    bottom: 0px !important;
  }
}


@media screen and (max-width: 330px){
  .catelog .custom-tab-list .custom-tab{
    font-size: 9px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/catalog/switch.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IAEtB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,uBAAuB;IACvB,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;IACX,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IAGE,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,sBAAsB;EACxB;;;EAGA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,eAAe;;EAEjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,8CAA8C;IAC9C,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;EACb;;EAEA,gBAAgB;;AAElB;EACE,gBAAgB;EAChB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,aAAa;EACb,iCAAiC;EACjC,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,WAAW;;EAEX;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB;EACF;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;;EAGA;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IAGE,sCAAsC;EACxC;;EAEA;IACE,sBAAsB;EACxB;AACF;;;AAGA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":[".switch {\n    position: relative;\n    display: inline-block;\n    width: 53px !important;\n    height: 28px !important;\n  }\n  \n  .switch input { \n    opacity: 0;\n    width: 0;\n    height: 0;\n  }\n  \n  .slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #ccc;\n    -webkit-transition: .4s;\n    transition: .4s;\n  }\n  \n  .slider:before {\n    position: absolute;\n    content: \"\";\n    height: 22px !important;\n    width: 22px !important;\n    left: 3px !important;\n    bottom: 3px;\n    background-color: white;\n    transition: .4s;\n  }\n  \n  input:checked + .slider {\n    background-color: #105293;\n  }\n  \n  input:focus + .slider {\n    box-shadow: 0 0 1px #2196F3;\n  }\n  \n  input:checked + .slider:before {\n    -webkit-transform: translateX(26px);\n    -ms-transform: translateX(26px);\n    transform: translateX(26px);\n  }\n  \n  .slider.round {\n    border-radius: 34px;\n  }\n  \n  .slider.round:before {\n    border-radius: 50%;\n  }\n\n  .prod_desc{\n    font-size: 12px;\n    width: 51%;\n    font-weight: 500;\n    margin-left: 3px;\n    display: flex;\n    align-self: flex-start;\n    flex-direction: column;\n  }\n\n\n  .searchDiv{\n    border: 1px solid #105293;\n  }\n\n  .searchDiv select {\n    font-size: 13px;\n    font-weight: 600;\n    background: #105293;\n    color: white;\n  }\n\n  .searchDiv input{\n    border: none;\n    outline: none;\n    font-size: 12px;\n    \n  }\n\n  .btnvar{\n    height: 31px !important;\n  }\n\n  .filterselection{\n    transition: opacity 1s ease, transform 1s ease;\n    border-radius: 10px;\n    width: 100%;\n    background-color: white;\n    min-height: 250px;\n    position: absolute;\n    z-index: 10;\n  }\n\n  /* React Tabs  */\n\n.catelog .custom-tab-list {\n  list-style: none;\n  display: flex;\n  background-color: transparent;\n}\n\n.catelog .custom-tab-list .custom-tab {\n  cursor: pointer;\n  height: 0;\n  width: 33.33%;\n  border-bottom: 35px solid #CCCCCC;\n  box-sizing: border-box;\n  background: white;\n  outline: none;\n  line-height: 2;\n  font-size: 13px;\n  font-weight: 600;\n  display: flex;\n  justify-content: center;\n  color: #000;\n\n  &:hover {\n    background-color: #d0d0d0;\n  }\n\n  &.react-tabs__tab--selected {\n    color: #105293;\n    transition: 300ms;\n    border-radius: 20px;\n    border-bottom: 3px solid\n  }\n}\n\n.inputWidth{\n  width: 75%;\n}\n\n.modalTrigerButton {\n  background: #d3d3d3;\n  border-radius: 14px;\n  color: #000;\n  cursor: pointer;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 6px;\n}\n.functionalButtons {\n  background: #d3d3d3;\n  border-radius: 12px;\n  color: #000;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 700;\n  height: 25px;\n  padding-top: 3px;\n  text-align: center;\n  width: 70px;\n}\n\n.syncContainers{\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n.syncContainers input{\n  width: 20px;\n  height: 20px;\n}\n.syncContainers label{\n  font-size: 17px;\n  color: black;\n}\n\n@media screen and (max-width: 450px) {\n  .inputWidth{\n    width: 100%;\n  }\n\n  .inputWidth::placeholder{\n    font-size: 12px;\n  }\n  \n\n  .catelog .custom-tab-list .custom-tab{\n    font-size: 10px;\n  }\n\n  .filterWidth{\n    width: 55% !important;\n  }\n  .sortWidth{\n    width: 40% !important;\n  }\n\n  .prod_desc .genericlabel{\n    font-size: 10px;\n  }\n\n  .badge{\n    font-size: 55% !important;\n  }\n\n  .switch {\n    position: relative;\n    display: inline-block;\n    width: 42px !important;\n    height: 21px !important;\n  }\n\n  input:checked + .slider:before {\n    -webkit-transform: translateX(17px) !important;\n    -ms-transform: translateX(17px) !important;\n    transform: translateX(17px) !important;\n  }\n\n  .slider:before{\n    bottom: 0px !important;\n  }\n}\n\n\n@media screen and (max-width: 330px){\n  .catelog .custom-tab-list .custom-tab{\n    font-size: 9px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
